import * as Yup from 'yup';
import { IActivationEducation } from 'core/interface/activation';

const initialValues: IActivationEducation = {
  isGraduated: false,
  school: '',
  study_field: '',
  degree: undefined,
  start: {
    month: '',
    year: '',
    day: ''
  },
  finish: {
    month: '',
    year: '',
    day: ''
  }
};

const validationSchema = () => {
  return Yup.object()
    .shape({
      isGraduated: Yup.boolean().default(false),
      school: Yup.string().required(),
      study_field: Yup.string().required(),
      degree: Yup.string().required(),
      start: Yup.object({
        month: Yup.string().required(),
        year: Yup.string().required(),
        day: Yup.string().required()
      }),
      finish: Yup.object({
        month: Yup.string(),
        year: Yup.string(),
        day: Yup.string()
      })
    })
    .test({
      name: 'finish-date-validation',
      message: 'Finish date must be after or equal to start date',
      test(value) {
        const { start, finish } = value;

        // Skip validation if any date fields are empty
        if (
          !start.year ||
          !start.month ||
          !start.day ||
          !finish.year ||
          !finish.month ||
          !finish.day
        ) {
          return true;
        }

        const startDate = new Date(`${start.year}-${start.month}-${start.day}`);
        const finishDate = new Date(
          `${finish.year}-${finish.month}-${finish.day}`
        );

        return finishDate >= startDate;
      }
    });
};

export { initialValues, validationSchema };
